import { useContext } from "react";
import {
  KursusFiltersContext,
  KursusFiltersEventContext,
} from "../../context/FiltersContext";
import FiltersSidebar from "./FiltersSidebar";
import KursusTypeFilter from "../pages/kursus/filters/KursusTypeFilter";
import KursusStartDatoFilter from "../pages/kursus/filters/KursusStartDatoFilter";
import KursusKategoriFilter from "../pages/kursus/filters/KursusKategoriFilter";
import KursusHotelFilter from "../pages/kursus/filters/KursusHotelFilter";
import CustomFilter from "./custom/CustomFilter";
import { KursusCustomFilterConfig } from "../../config/filter/CustomFilterConfig";

export default function FiltersKursus() {
  // filters context
  const updateFilters = useContext(KursusFiltersEventContext);

  return (
    <FiltersSidebar
      contextType="Kursus"
      queryFilterEventContext={KursusFiltersEventContext}
      onReset={() => {
        updateFilters({
          event: "reset",
        });
      }}
    >
      <KursusTypeFilter />
      <KursusKategoriFilter />
      <KursusStartDatoFilter />
      <KursusHotelFilter />
      <CustomFilter
        filterConfig={KursusCustomFilterConfig}
        queryFilterContext={KursusFiltersContext}
        queryFilterEventContext={KursusFiltersEventContext}
      />
    </FiltersSidebar>
  );
}
